export default "__VITE_ASSET__CgciJIAo__"